var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTechnologyHeadAiNeurolink = function SvgTechnologyHeadAiNeurolink(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.384,23.283V20.509H6a2.774,2.774,0,0,1-2.774-2.775V14.96H1.465a.7.7,0,0,1-.647-.943C3.172,7.911,4.6,2.475,11.2,2.475"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.213,5.388H14.47A1.168,1.168,0,0,0,15.638,4.22V3.637a1.168,1.168,0,0,1,1.168-1.168h2.919"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 11.55,
    y1: 8.892,
    x2: 17.39,
    y2: 8.892
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 21.477,
    cy: 2.469,
    r: 1.752
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.213,12.4H14.47a1.167,1.167,0,0,1,1.168,1.167h0a1.168,1.168,0,0,0,1.168,1.168h2.919"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 21.477,
    cy: 14.731,
    r: 1.752
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 19.141,
    cy: 8.892,
    r: 1.752
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 17.094,
    y1: 23.283,
    x2: 17.094,
    y2: 18.414
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTechnologyHeadAiNeurolink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "technology-head-ai-neurolink.0e80f09d4e8964f2e8213850be01fe76.svg";